var _defs, _rect, _polygon, _rect2, _polygon2, _rect3, _polygon3, _line, _line2, _line3, _line4, _line5, _line6, _polygon4, _polyline, _line7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpFlyerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.g,.h{fill:none;}.b{fill:#3c3c46;opacity:0.15;}.b,.d,.f,.h{fill-rule:evenodd;}.c,.f{fill:#89d9fb;}.c,.g,.h{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d{fill:#ffefe0;}.e{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-flyer-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "49.7 31.34 68.72 31.34 77.42 16.28 117.77 39.58 96.3 76.77 96.3 114.86 81.44 129.72 49.7 129.72 49.7 113.88 28.23 101.48 49.7 64.29 49.7 31.34"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 17.81,
    y: 41.23,
    width: 98.38,
    height: 46.6,
    transform: "translate(-22.38 90.29) rotate(-60)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "90.3 108.86 75.44 123.72 43.7 123.72 43.7 75.97 90.3 75.97 90.3 108.86"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 43.7,
    y: 75.97,
    width: 23.3,
    height: 47.75
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "90.3 77.97 43.7 86.55 43.7 25.34 90.3 25.34 90.3 77.97"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 82.96,
    y1: 95,
    x2: 51.21,
    y2: 95
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 82.87,
    y1: 101,
    x2: 65.57,
    y2: 101
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 60.4,
    y1: 101,
    x2: 51.13,
    y2: 101
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 66.82,
    y1: 107,
    x2: 51.13,
    y2: 107
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 82.87,
    y1: 64.87,
    x2: 51.13,
    y2: 64.87
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 82.87,
    y1: 57.45,
    x2: 51.13,
    y2: 57.45
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "43.7 25.34 90.3 25.34 90.3 108.86 75.44 123.72 43.7 123.72 43.7 25.34"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "h",
    points: "75.44 123.72 75.44 108.86 90.3 108.86"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 90.3,
    y1: 77.97,
    x2: 43.7,
    y2: 86.54
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpFlyerIcon);
export default __webpack_public_path__ + "static/media/CP-flyer-icon.0a5b32fb2d9f243d04fe038a2329fef4.svg";
export { ForwardRef as ReactComponent };